import React from 'react'

import { Category } from '../../../../../containers/GamesBlock/types'
import useCategory from '../../../hooks/useCategory'
import { IconItem } from '../../IconItem'

interface Props {
  isSearching: boolean
  categories?: Category[]
  category?: string
}

export default function IconAll({ category, categories, isSearching }: Props) {
  const { changeCategory } = useCategory()
  const allCategory = categories?.find(({ slug }) => slug === 'all')
  const isEnabled = !isSearching && category === 'all'

  const onClick = () => {
    changeCategory('all')
  }

  if (!allCategory) {
    return null
  }

  return (
    <IconItem
      onClick={onClick}
      icon={allCategory.icon}
      label={allCategory.label}
      isEnabled={isEnabled}
    />
  )
}
